import moment from 'moment';
import useAxiosInterceptor from 'src/services/interceptor';
import {
  ASSIGN_THERAPIST_TASK,
  EDIT_TASK_TIME,
  GET_ALL_TASK_TYPE,
  GET_ALL_THERAPIST,
  GET_ALL_THERAPIST_DICIPLINE,
  GET_ALL_THERAPIST_TASK,
  MIGRATE_THERAPIST_PATIENT,
  MIGRATE_THERAPIST_TASK,
  REARRANGE_THERAPIST_TASK,
  THERAPIST_ASSIGN_DIALOG_TASK,
  UNASSIGN_THERAPIST_PATIENT,
  UNDO_THERAPIST_ASSIGNMENT,
} from '../constants';

class TherapistSchedulingServices {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getAllTherapistTask = (payload: any) => {
    const date = payload.data?.localDate;

    return this.axiosInstance.get(
      `${GET_ALL_THERAPIST_TASK(payload.data.providerId, payload.data.isV2)}?type=${
        payload.data.type
      }&active=${payload.data.active}&discipline=${
        payload.data.discipline
      }&localDate=${date}&skill=${payload.data.skill}&searchString=&page=${
        payload?.pageSize > 20 ? '0' : payload.pageNo
      }&pageSize=${payload?.pageSize ? payload?.pageSize : '20'}`,
      {
        signal: payload?.data?.signal,
      }
    );
  };

  getSkillListScheduling = (payload: any) => {
    return this.axiosInstance.get(`/provider/${payload?.therapistId}/scheduling/get-all-skills`);
  };

  getAllTaskType = (payload: any) => {
    return this.axiosInstance.get(
      `${GET_ALL_TASK_TYPE(payload.providerId)}?active=${payload.active}`
    );
  };

  getAllTherapistList = (payload: any) => {
    const forFilter = payload?.data?.forFilter || false;
    if (payload?.data?.filterByUuid)
      return this.axiosInstance.post(
        `${GET_ALL_THERAPIST(payload.data.providerId)}?localDate=${
          payload.data.localDate
        }&sortDirection=${payload.data.sortBy}&discipline=${payload.data.discipline}&page=${
          payload?.pageSize > 20 ? '0' : payload.pageNo
        }&pageSize=${payload?.pageSize ? payload?.pageSize : '20'}&searchString=${
          payload?.data?.searchData || ''
        }&forFilter=${forFilter}`,
        {
          filterByUuid: payload?.data?.filterByUuid,
        },
        {
          signal: payload?.data?.signal,
        }
      );
    else
      return this.axiosInstance.post(
        `${GET_ALL_THERAPIST(payload.data.providerId)}?localDate=${
          payload.data.localDate
        }&sortDirection=${payload.data.sortBy}&discipline=${payload.data.discipline}&page=${
          payload?.pageSize > 20 ? '0' : payload.pageNo
        }&pageSize=${payload?.pageSize ? payload?.pageSize : '20'}&searchString=${
          payload?.data?.searchData || ''
        }&forFilter=${forFilter}`,
        {},
        {
          signal: payload?.data?.signal,
        }
      );
  };

  AddTask = (payload: any) => {
    return this.axiosInstance.post(`provider/${payload.providerId}/scheduling`, payload.data);
  };

  therapistSchedulingTaskEdit = (payload: any) => {
    return this.axiosInstance.put(`provider/${payload.providerId}/scheduling`, payload.data);
  };

  getAllTherapistDiciplineList = (payload: any) => {
    return this.axiosInstance.get(
      `${GET_ALL_THERAPIST_DICIPLINE(
        payload.providerId,
        payload.data.isV2
      )}?localDate=${payload?.localDate}`
    );
  };

  therapistAssignTask = (payload: any) => {
    return this.axiosInstance.post(
      `${ASSIGN_THERAPIST_TASK(payload.providerId, payload.therapistId)}?assign-date=${
        payload.date
      }&discipline=${payload.meta.discipline}`,
      payload.data
    );
  };

  migrateTherapistAssignedTask = (payload: any) => {
    return this.axiosInstance.put(
      `${MIGRATE_THERAPIST_TASK(
        payload.providerId
      )}?assignDate=${payload?.assignDate}&singleAssign=${true}&sourceTherapist=${payload?.sourceTherapist}&targetTherapist=${payload?.targetTherapist}&taskId=${payload?.taskId}`
    );
  };

  migrateTherapistAssignedPatient = (payload: any) => {
    return this.axiosInstance.put(
      `${MIGRATE_THERAPIST_PATIENT(
        payload.providerId
      )}?assignDate=${payload?.assignDate}&sourceTherapist=${payload?.sourceTherapist}&targetTherapist=${payload?.targetTherapist}&patientId=${payload?.patientId}`
    );
  };

  undoTherapistAssignment = (payload: any) => {
    return this.axiosInstance.put(
      `${UNDO_THERAPIST_ASSIGNMENT(payload.providerId, payload.therapistId)}`,
      payload.requestBody
    );
  };

  unAssignTherapistPatient = (payload: any) => {
    return this.axiosInstance.put(
      `${UNASSIGN_THERAPIST_PATIENT(
        payload.providerId,
        payload.therapistId
      )}?assign-date=${payload?.currentDate}&patientId=${payload?.patientId}`
    );
  };

  rearrangeTherapistTask = (payload: any) => {
    return this.axiosInstance.post(
      `${REARRANGE_THERAPIST_TASK(payload.providerId)}?discipline=${payload.dicipline}`,
      payload.data
    );
  };

  editTaskTime = (payload: any) => {
    return this.axiosInstance.put(
      `${EDIT_TASK_TIME(payload.providerId)}?time=${payload.time}`,
      payload.requestBody
    );
  };

  therapistDialogAssignTask = (payload: any) => {
    return this.axiosInstance.post(
      `${THERAPIST_ASSIGN_DIALOG_TASK(payload.providerId, payload.therapistId)}?assign-date=${
        payload.date
      }`,
      payload.data
    );
  };

  getSchedulePrintPDFUrl = (providerUUID: string, dateString: string) => {
    return this.axiosInstance.get(
      `/provider/${providerUUID}/scheduling/${providerUUID}/schedule-print/${dateString}`
    );
  };

  maintainTherapistFilter = (payload: any) => {
    return this.axiosInstance.put(`provider/therapist-filter/${payload.therapistId}`, {
      discipline: payload?.discipline,
      providerIds: payload?.therapists,
    });
  };

  getAllMaintainedTherapists = (payload: any) => {
    return this.axiosInstance.get(
      `provider/therapist-filter/${payload.therapistId}?discipline=${payload?.discipline}`
    );
  };
}

const therapistSchedulingServices = new TherapistSchedulingServices();

Object.freeze(therapistSchedulingServices);

export default therapistSchedulingServices;
